const getCouncils = () => {
  const councils = localStorage.getItem("councils")
    ? JSON.parse(localStorage.getItem("councils"))
    : null;

  if (councils) return councils;

  return null;
};

const InitialState = {
  councils: getCouncils(),
};

const CouncilsDataReducer = (state = InitialState, action) => {
  if (action.type === "Save_Councils_Data") {
    const newState = {
      councils: action.payload,
    };

    localStorage.setItem("councils", JSON.stringify(action.payload));

    return newState;
  }

  return state;
};

export default CouncilsDataReducer;
